<template>
	<main-content>
		
	</main-content>
</template>

<script>
	export default {
		data() {
			return {
				companies: 0,
				users: 0
			};
		},
		computed: {
			loading: {
				get() {
					return this.$store.state.loading;
				},
				set(value) {
					this.$store.state.loading = value;
				}
			}
		},
		methods: {
			async load() {
				this.loading++;
				try {
					const data = await this.$get('/json/dashboard');
					this.companies = data.companies;
					this.users = data.users;
				} catch(e) {}
				this.loading--;
			}
		},
		async mounted() {
			await this.load();
		}
	}
</script>